import cryptoJs from "crypto-js";

const secretKey = "unionmobilekookhwa20230906open11"; // 32자리 비밀키
const iv = "unionmobileivhuh"; // 16자리 iv

// 암호화
export const encrypt = (text) => {
  const cipher = cryptoJs.AES.encrypt(
    text,
    cryptoJs.enc.Utf8.parse(secretKey),
    {
      iv: cryptoJs.enc.Utf8.parse(iv),
      padding: cryptoJs.pad.Pkcs7,
      mode: cryptoJs.mode.CBC,
    }
  );

  return cipher.toString();
};

// 복호화
export const decrypt = (encryptedText) => {
  const decipher = cryptoJs.AES.decrypt(
    encryptedText,
    cryptoJs.enc.Utf8.parse(secretKey),
    {
      iv: cryptoJs.enc.Utf8.parse(iv),
      padding: cryptoJs.pad.Pkcs7,
      mode: cryptoJs.mode.CBC,
    }
  );

  return decipher.toString(cryptoJs.enc.Utf8);
};

// SHA256 암호화

export const sha256 = (text) => {
  const hash = cryptoJs.SHA256(text);
  return hash.toString(cryptoJs.enc.Hex);
};
